<template>
  <modal-default
    ref="modal"
    title=""
    hide-close-button
  >
    <are-you-sure v-if="currentScreen === screens.AreYouSure"/>

    <reason-why
      v-if="currentScreen === screens.ReasonWhy"
      v-model="cancelAttempt.cancellation_comment"
      @reason="setReason"
    />

    <div v-if="currentScreen === screens.Offer">
      <offer-expert-call v-if="showExpertOffer" @accepted="acceptExpertOffer"/>
<!--      <offer-walk-thru-video v-else-if="showWalkThruOffer" @accepted="acceptWalkThruOffer"/>-->
      <offer-discount v-else @accepted="acceptDiscountOffer"/>
    </div>

    <pause-subscription v-if="currentScreen === screens.PauseSubscription" @pause="pauseAccount"/>

    <owner-feedback
      v-if="currentScreen === screens.OwnerFeedback"
      v-model="cancelAttempt.feedback_for_owner"
    />

    <last-chance v-if="currentScreen === screens.LastChance"/>

    <cancel-confirmation v-if="currentScreen === screens.CancelConfirmation"/>
    <pause-confirmation v-if="currentScreen === screens.PauseConfirmation"/>
    <offer-confirmation-discount v-if="currentScreen === screens.OfferConfirmationDiscount"/>
    <offer-confirmation-expert v-if="currentScreen === screens.OfferConfirmationExpert"/>
    <offer-confirmation-walk-thru v-if="currentScreen === screens.OfferConfirmationWalkThru"/>

    <template v-slot:footer>
      <div v-if="showLogoutButton" class="buttons_wrapper flex-centered">
        <button-default @click="logout" :disabled="isLoading">Logout</button-default>
      </div>

      <div v-else-if="showCloseButton" class="buttons_wrapper flex-centered">
        <button-default @click="closeModal">Close</button-default>
      </div>

      <div v-else class="buttons_wrapper flex-between">
        <button-link @click="stopCancelAttempt" :disabled="isLoading">Nevermind</button-link>

        <div class="flex">
          <button-outlined v-if="showBackButton" @click="back">Back</button-outlined>
          <button-default @click="next" :disabled="isLoading || disableNextButton">{{ nextButtonText }}</button-default>
        </div>
      </div>
    </template>
  </modal-default>
</template>

<script>
import AreYouSure from "../close-account-modal/AreYouSure.vue";
import PauseSubscription from "../close-account-modal/PauseSubscription.vue";
import ReasonWhy from "../close-account-modal/ReasonWhy.vue";
import CancelConfirmation from "../close-account-modal/CancelConfirmation.vue";
import OwnerFeedback from "../close-account-modal/OwnerFeedback.vue";
import LastChance from "../close-account-modal/LastChance.vue";
import OfferDiscount from "../close-account-modal/OfferDiscount.vue";
import OfferExpertCall from "../close-account-modal/OfferExpertCall.vue";
import OfferWalkThruVideo from "../close-account-modal/OfferWalkThruVideo.vue";
import OfferConfirmationDiscount from "../close-account-modal/OfferConfirmationDiscount.vue";
import PauseConfirmation from "../close-account-modal/PauseConfirmation.vue";
import OfferConfirmationExpert from "../close-account-modal/OfferConfirmationExpert.vue";
import OfferConfirmationWalkThru from "../close-account-modal/OfferConfirmationWalkThru.vue";
import api from "../../../api";
import Console from "../../../services/console";
import {ENUMS} from "../../../services/enums";
import auth from "../../../api/auth";

export default {
  name: "CloseAccountModal",
  components: {
    OfferConfirmationWalkThru,
    OfferConfirmationExpert,
    PauseConfirmation,
    OfferConfirmationDiscount,
    OfferWalkThruVideo,
    OfferExpertCall,
    OfferDiscount,
    LastChance,
    OwnerFeedback,
    CancelConfirmation,
    ReasonWhy,
    PauseSubscription,
    AreYouSure
  },
  data() {
    return {
      isLoading: false,
      screens: {
        AreYouSure: 'AreYouSure',
        PauseSubscription: 'PauseSubscription',
        ReasonWhy: 'ReasonWhy',
        Offer: 'Offer',
        OwnerFeedback: 'OwnerFeedback',
        LastChance: 'LastChance',
        CancelConfirmation: 'CancelConfirmation',
        PauseConfirmation: 'PauseConfirmation',
        OfferConfirmationDiscount: 'OfferConfirmationDiscount',
        OfferConfirmationExpert: 'OfferConfirmationExpert',
        OfferConfirmationWalkThru: 'OfferConfirmationWalkThru',
      },
      currentScreen: null,
      cancelAttempt: {
        outcome: null,
        last_screen: null,
        pause_duration: null,
        cancellation_reason: null,
        cancellation_comment: null,
        accepted_offer: null,
        coupon_code: null,
        feedback_for_owner: null,
        ab_option_used: null,
      },
    };
  },
  mounted() {
    // Need to set initial currentScreen and cancelAttempt.last_screen
    this.reset()
  },
  computed: {
    accountId() {
      return this.$store.getters.account.id;
    },
    steps() {
      const randomNumber = Math.random();

      if(randomNumber < 0.5) {
        this.cancelAttempt.ab_option_used = ENUMS.CancelAttemptABOptionsEnum.OfferFirst.value

        return {
          [this.screens.AreYouSure]: {
            back: () => {
              this.stopCancelAttempt()
            },
            next: () => {
              this.setScreen(this.screens.ReasonWhy)
            },
          },
          [this.screens.ReasonWhy]: {
            back: () => {
              this.setScreen(this.screens.AreYouSure)
            },
            next: () => {
              this.setScreen(this.screens.Offer)
            },
          },
          [this.screens.Offer]: {
            back: () => {
              this.setScreen(this.screens.ReasonWhy)
            },
            next: () => {
              this.setScreen(this.screens.PauseSubscription)
            },
          },
          [this.screens.PauseSubscription]: {
            back: () => {
              this.setScreen(this.screens.Offer)
            },
            next: () => {
              this.setScreen(this.screens.OwnerFeedback)
            },
          },
          [this.screens.OwnerFeedback]: {
            back: () => {
              this.setScreen(this.screens.PauseSubscription)
            },
            next: () => {
              this.setScreen(this.screens.LastChance)
            },
          },
          [this.screens.LastChance]: {
            back: () => {
              this.setScreen(this.screens.OwnerFeedback)
            },
            next: () => {
              this.cancelAccount()
            },
          },
        }
      } else {
        this.cancelAttempt.ab_option_used = ENUMS.CancelAttemptABOptionsEnum.PauseFirst.value

        return {
          [this.screens.AreYouSure]: {
            back: () => {
              this.stopCancelAttempt()
            },
            next: () => {
              this.setScreen(this.screens.PauseSubscription)
            },
          },
          [this.screens.PauseSubscription]: {
            back: () => {
              this.setScreen(this.screens.AreYouSure)
            },
            next: () => {
              this.setScreen(this.screens.ReasonWhy)
            },
          },
          [this.screens.ReasonWhy]: {
            back: () => {
              this.setScreen(this.screens.PauseSubscription)
            },
            next: () => {
              this.setScreen(this.screens.Offer)
            },
          },
          [this.screens.Offer]: {
            back: () => {
              this.setScreen(this.screens.ReasonWhy)
            },
            next: () => {
              this.setScreen(this.screens.OwnerFeedback)
            },
          },
          [this.screens.OwnerFeedback]: {
            back: () => {
              this.setScreen(this.screens.Offer)
            },
            next: () => {
              this.setScreen(this.screens.LastChance)
            },
          },
          [this.screens.LastChance]: {
            back: () => {
              this.setScreen(this.screens.OwnerFeedback)
            },
            next: () => {
              this.cancelAccount()
            },
          },
        }
      }
    },
    showLogoutButton() {
      // Show only a logout button if they paused or cancelled
      const logoutScreens = [
        this.screens.CancelConfirmation,
        this.screens.PauseConfirmation
      ]

      return logoutScreens.includes(this.currentScreen)
    },
    showCloseButton() {
      // Show only a close button if they accepted an offer
      const closeScreens = [
        this.screens.OfferConfirmationDiscount,
        this.screens.OfferConfirmationExpert,
        this.screens.OfferConfirmationWalkThru
      ]

      return closeScreens.includes(this.currentScreen)
    },
    showBackButton() {
      return this.currentScreen !== this.screens.AreYouSure
    },
    nextButtonText() {
      if (this.currentScreen === this.screens.Offer) return 'Decline Offer'
      if (this.currentScreen === this.screens.LastChance) return 'Cancel Account'
      return 'Next'
    },
    disableNextButton() {
      // This makes it required for them to choose a reason
      return this.currentScreen === this.screens.ReasonWhy && this.cancelAttempt.cancellation_reason === null
    },
    showExpertOffer() {
      return this.cancelAttempt.cancellation_reason === ENUMS.CancelAttemptReasonEnum.TooDifficult.value
    },
    showWalkThruOffer() {
      // Note Josh & Kevin don't want to do a walkthru video but I'm leaving this here just in case
      return this.cancelAttempt.cancellation_reason === ENUMS.CancelAttemptReasonEnum.NotSatisfied.value
    }
  },
  methods: {
    open() {
      this.$refs.modal.open();
    },
    closeModal() {
      Console.log('Called closeModal(), Trying to close the modal');
      this.reset()
      this.$refs.modal.close();
    },
    reset() {
      // Return currentScreen to beginning when closed
      this.currentScreen = this.screens.AreYouSure

      // Return the cancel attempt to the default when closed
      this.cancelAttempt.outcome = null
      this.cancelAttempt.last_screen = this.screens.AreYouSure
      this.cancelAttempt.pause_duration = null
      this.cancelAttempt.cancellation_reason = null
      this.cancelAttempt.cancellation_comment = null
      this.cancelAttempt.accepted_offer = null
      this.cancelAttempt.coupon_code = null
      this.cancelAttempt.feedback_for_owner = null
    },
    logout() {
      this.closeModal();
      auth.logout();
    },
    back() {
      this.steps[this.currentScreen].back()
    },
    next() {
      this.steps[this.currentScreen].next()
    },
    createCancelAttempt() {
      Console.log('Called createCancelAttempt(), Making Api Call');
      return api.cancelAccount.createCancelAttempt(this.cancelAttempt)
    },
    setScreen(screen) {
      this.cancelAttempt.last_screen = screen
      this.currentScreen = screen
    },
    setReason(reason) {
      this.cancelAttempt.cancellation_reason = reason
    },
    stopCancelAttempt() {
      Console.log('Called stopCancelAttempt()', ENUMS);
      this.cancelAttempt.outcome = ENUMS.CancelAttemptOutcomeEnum.Stopped.value

      Console.log('Set CancelAttempt: ', this.cancelAttempt.outcome);
      this.createCancelAttempt()
      this.closeModal()
    },
    pauseAccount(days) {
      this.isLoading = true

      return api.cancelAccount.pauseAccount(days).then(() => {
        this.cancelAttempt.outcome = ENUMS.CancelAttemptOutcomeEnum.Paused.value
        this.cancelAttempt.pause_duration = days
        this.createCancelAttempt()
        this.setScreen(this.screens.PauseConfirmation)
        this.isLoading = false
      })
    },
    acceptDiscountOffer() {
      const couponCode = process.env.MIX_STRIPE_CANCELLATION_COUPON;
      this.isLoading = true

      return api.cancelAccount.addDiscount(couponCode).then(() => {
        this.cancelAttempt.outcome = ENUMS.CancelAttemptOutcomeEnum.Discounted.value
        this.cancelAttempt.accepted_offer = ENUMS.CancelAttemptAcceptedOfferEnum.Discount.value
        this.cancelAttempt.coupon_code = couponCode
        this.createCancelAttempt()
        this.setScreen(this.screens.OfferConfirmationDiscount)
        this.isLoading = false
      })
    },
    acceptExpertOffer() {
      this.cancelAttempt.outcome = ENUMS.CancelAttemptOutcomeEnum.Stopped.value
      this.cancelAttempt.accepted_offer = ENUMS.CancelAttemptAcceptedOfferEnum.ExpertCall.value
      this.createCancelAttempt()
      this.setScreen(this.screens.OfferConfirmationExpert)
    },
    acceptWalkThruOffer() {
      this.cancelAttempt.outcome = ENUMS.CancelAttemptOutcomeEnum.Stopped.value
      this.cancelAttempt.accepted_offer = ENUMS.CancelAttemptAcceptedOfferEnum.WalkThruVideo.value
      this.createCancelAttempt()
      this.setScreen(this.screens.OfferConfirmationWalkThru)
    },
    cancelAccount() {
      this.isLoading = true

      api.cancelAccount.cancelAccount(this.accountId).then(() => {
        this.cancelAttempt.outcome = ENUMS.CancelAttemptOutcomeEnum.Cancelled.value
        this.createCancelAttempt()
        this.setScreen(this.screens.CancelConfirmation)
        this.isLoading = false
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.buttons_wrapper {
  display: flex;
  width: 100%;
}
</style>
